import { Sender } from 'xstate';

import DeviceOrientation from '../../../ports-frontend/DeviceOrientation';
import asyncCallback from '../../../framework/logic/utils/asyncCallback';

export const watchScreenMode = () =>
  asyncCallback(
    async (
      callback: Sender<{
        type: 'ENVIRONMENT_SCREEN_SIZE_CHANGED';
        data: {
          size: string;
        };
      }>
    ) => {
      const subscriptions: Function[] = [];
      subscriptions.push(
        await DeviceOrientation.onScreenSizeChange(size => {
          callback({
            type: 'ENVIRONMENT_SCREEN_SIZE_CHANGED',
            data: {
              size,
            },
          });
        })
      );
      return () => {
        subscriptions.forEach(unsub => unsub());
      };
    }
  );
